module.exports = __webpack_public_path__ + "img/maimon_vid.5b16e680.gif";